var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import { concatStyles } from 'utils';
var BUTTON_STYLES = 'rounded font-body text-white text-sm text-center uppercase px-5 py-3 w-auto';
var LINK_STYLES = 'flex font-body text-actionable underline';
var DISABLED_STYLES = 'opacity-50 cursor-not-allowed';
export var backgroundStyles = function (appearance) {
    switch (appearance) {
        case 'primary':
            return 'bg-primary';
        case 'secondary':
            return 'bg-secondary';
        case 'destructive':
            return 'bg-error';
        case 'accent':
            return 'bg-accent';
        case 'custom':
        case 'link':
            return '';
        default:
            return 'bg-actionable';
    }
};
var alignmentStyles = function (alignment) {
    switch (alignment) {
        case 'center':
            return 'w-auto mx-auto';
        case 'right':
            return 'w-auto ml-auto';
        case 'left':
            return 'w-auto mr-auto';
        case 'stretch':
            return 'w-full';
        default:
            return 'w-auto';
    }
};
export var Button = function (_a) {
    var align = _a.align, appearance = _a.appearance, children = _a.children, className = _a.className, disabled = _a.disabled, _b = _a.style, style = _b === void 0 ? {} : _b, onClick = _a.onClick, form = _a.form;
    var _c = useState(false), focus = _c[0], setFocus = _c[1];
    var _d = useState(false), hover = _d[0], setHover = _d[1];
    var toggleState = function (state, newVal) { return function () {
        state === 'hover' ? setHover(newVal) : setFocus(newVal);
    }; };
    var brightness = focus ? 0.97 : hover ? 1.03 : 1;
    return (React.createElement("button", { className: concatStyles([
            appearance === 'link' ? LINK_STYLES : BUTTON_STYLES,
            backgroundStyles(appearance),
            alignmentStyles(align),
            disabled ? DISABLED_STYLES : '',
            className,
        ]), disabled: disabled, style: __assign({ filter: brightness !== 1 ? "brightness(" + brightness + ")" : '' }, style), onMouseDown: toggleState('focus', true), onMouseUp: toggleState('focus', false), onMouseEnter: toggleState('hover', true), onMouseLeave: toggleState('hover', false), onClick: onClick, form: form }, children));
};
Button.displayName = 'Form.Button';
